import { styled } from '@mui/material';
import CardHeader from '@mui/material/CardHeader';

export const StyledCardHeader = styled(CardHeader)(({ theme }) => ({
  padding: theme.spacing(2),
  paddingBottom: theme.spacing(0),
}));
